import React from 'react'
import PropTypes from 'prop-types'
import { compose, pure } from 'recompose'

import LargeTitle from '../../atoms/LargeTitle/LargeTitle'

import './QuestionPrepare.css'

const QuestionPrepare = ({ children }) => (
  <div styleName="container">
    <div styleName="l-text">
      <LargeTitle>{children}</LargeTitle>
    </div>
  </div>
)

QuestionPrepare.propTypes = {
  children: PropTypes.string.isRequired
}

export default compose(pure)(QuestionPrepare)
